export default __webpack_public_path__ + "static/media/vietFlag.ad670c4b.svg";